import { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Loader2 } from "lucide-react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AspiringAuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const handleCallback = async () => {
      // Get session_id from URL fragment (hash)
      const hash = location.hash || window.location.hash;
      const params = new URLSearchParams(hash.replace('#', ''));
      const sessionId = params.get('session_id');
      const error = params.get('error');
      
      if (error) {
        console.error('Auth error:', error);
        navigate('/aspiring/auth');
        return;
      }
      
      if (sessionId) {
        try {
          // Exchange session_id for aspiring founder token
          const res = await fetch(`${BACKEND_URL}/api/aspiring/auth/session`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            credentials: 'include',
            body: JSON.stringify({ session_id: sessionId })
          });
          
          if (res.ok) {
            const userData = await res.json();
            navigate('/aspiring/dashboard', { state: { user: userData } });
          } else {
            console.error('Session exchange failed');
            navigate('/aspiring/auth');
          }
        } catch (e) {
          console.error('Session exchange failed:', e);
          navigate('/aspiring/auth');
        }
      } else {
        navigate('/aspiring/auth');
      }
    };
    
    handleCallback();
  }, [navigate, location]);

  return (
    <div className="min-h-screen bg-amber-50 flex items-center justify-center">
      <div className="text-center">
        <Loader2 className="w-8 h-8 animate-spin text-amber-500 mx-auto mb-4" />
        <p className="text-slate-600">Completing sign in...</p>
      </div>
    </div>
  );
}
